/**
 * Module-level state for the Firebase session fallback feature flag.
 *
 * This module provides a getter/setter pair so that the feature flag value
 * (synced from LaunchDarkly via a React hook) can be read by non-React code
 * such as session init functions and logout handlers.
 */

let firebaseSessionFallbackEnabled = false;

export function isFirebaseSessionFallbackEnabled(): boolean {
  return firebaseSessionFallbackEnabled;
}

export function setFirebaseSessionFallbackEnabled(enabled: boolean): void {
  firebaseSessionFallbackEnabled = enabled;
}
